import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 0% 0 2% 0%;
  gap: 16px;
`

export const InventoryToolbar = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 16px;
`

export const InventorySummary = styled.div`
  flex: 1 1 550px;
  min-width: 0;
  padding: 14px 18px;
  background: #eef5fa;
  border-radius: 12px;
`

export const InventoryButtons = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  flex-wrap: wrap;
  flex: 0 1 auto;
  gap: 16px;

  > button {
    margin: 0;
  }

  @media (max-width: 900px) {
    width: 100%;
    justify-content: flex-start;
  }
`

export const UsersTableCard = styled.section`
  width: 100%;
  box-sizing: border-box;
  padding: 16px;
  background: #ffffff;
  border-radius: 12px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);

  .process-users-search-table,
  .process-users-added-table,
  .process-users-360-table {
    padding: 0;
    background: transparent;

    > div {
      border: 0;
      border-radius: 0;
      box-shadow: none;
      overflow-x: auto;

      &::after {
        display: none;
      }
    }

    table {
      width: 100%;
      min-width: 0 !important;
      table-layout: fixed;
    }

    thead {
      background: #eff5fb;
      border-radius: 12px;
    }

    th,
    td {
      padding: 14px 12px;
      text-align: left;
      white-space: normal;
      overflow-wrap: anywhere;
    }

    th {
      color: #163247;
      font-size: 0.82rem;
      font-weight: 800;
      text-transform: none;
    }

    td {
      color: #536b84;
      border-bottom: 1px solid #e5edf4;
    }

    tbody {
      min-height: 0;
      height: auto;
    }

    tbody td {
      padding: 8px 12px;
    }

    tbody td[data-label='Acciones'] > div {
      min-height: 44px;
      padding-left: 0;
    }

    tbody tr,
    tbody tr:nth-child(even) {
      background: #ffffff;
    }

    td[data-label='Acciones'] {
      text-align: center;
      white-space: nowrap;
    }

    @media (max-width: 1100px) {
      table {
        min-width: 1050px !important;
      }
    }
  }

  .process-users-search-table {
    col:nth-child(1) { width: 15% !important; }
    col:nth-child(2) { width: 26% !important; }
    col:nth-child(3) { width: 14% !important; }
    col:nth-child(4) { width: 14% !important; }
    col:nth-child(5) { width: 17% !important; }
    col:nth-child(6) { width: 14% !important; }
  }

  .process-users-added-table {
    col:nth-child(1) { width: 5% !important; }
    col:nth-child(2) { width: 15% !important; }
    col:nth-child(3) { width: 23% !important; }
    col:nth-child(4) { width: 12% !important; }
    col:nth-child(5) { width: 12% !important; }
    col:nth-child(6) { width: 18% !important; }
    col:nth-child(7) { width: 15% !important; }
  }

  .process-users-360-table {
    col:nth-child(1) { width: 5% !important; }
    col:nth-child(2) { width: 23% !important; }
    col:nth-child(3) { width: 15% !important; }
    col:nth-child(4) { width: 15% !important; }
    col:nth-child(5) { width: 14% !important; }
    col:nth-child(6) { width: 13% !important; }
    col:nth-child(7) { width: 15% !important; }
  }
`

export const UsersTableHeading = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 16px;
  margin-bottom: 12px;
`

export const UsersSearchHeading = styled.div`
  display: grid;
  grid-template-columns: max-content minmax(0, 1fr);
  align-items: center;
  gap: 16px;
  margin-bottom: 12px;

  @media (max-width: 1050px) {
    grid-template-columns: 1fr;
  }
`

export const UsersTableTitle = styled.h3`
  margin: 0;
  color: #163247;
  font-family: 'Public Sans', sans-serif;
  font-size: 20px;
  font-weight: 700;
`

export const UsersSearchControls = styled.div`
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr)) auto auto;
  align-items: center;
  gap: 12px;
  min-width: 0;

  @media (max-width: 760px) {
    display: flex;
    flex-wrap: wrap;
  }
`

export const HeaderContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding-top: 40px;
  padding-bottom: 1%;
  background-color: #eff3fa;
  margin-bottom: 0;
`

export const TitleContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  width: 100%;
  gap: 20px;
  margin-bottom: 20px;
`

export const TitleIcon = styled.img`
  width: 65px;
  height: 50px;
  margin-left: 30px;
  margin-bottom: 30px;
`

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  min-height: auto;
`

export const SelectorsContainer = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  height: 60px;
  align-items: center;
`

export const FooterContent = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  min-height: 56px;
  align-items: center;
  justify-content: flex-end;
  margin-top: 18px;
`

export const ContainerActions = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  align-self: flex-end;
  padding-left: 20px;
  gap: 20px;
  min-height: 60px;
`

export const TextViewMore = styled.p`
  font-family: 'Public Sans', sans-serif;
  font-style: normal;
  font-weight: 700;
  color: #c6016b;
  cursor: pointer;
`

export const EditContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
`

export const ActionButton = styled.button`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  width: 100%;
  min-height: 44px;
  border: 0;
  padding: 0;
  background: transparent;
  font: inherit;
  cursor: pointer;

  &:disabled {
    cursor: default;
  }
`

export const DeleteActionButton = styled(ActionButton)`
  width: auto;
  min-width: 118px;
  padding: 0 12px;
  border: 1px solid #d20000;
  border-radius: 22px;
  background: #ffffff;
  color: #d20000;

  > p {
    margin: 0 0 0 6px;
  }

  &:hover:not(:disabled) {
    background: #fff4f4;
  }

  &:focus-visible {
    outline: 2px solid #d20000;
    outline-offset: 2px;
  }

  &:disabled {
    opacity: 0.6;
  }
`

export const VioletLink = styled.a`
  color: #c6016b;
  cursor: pointer;
  text-decoration: none;
  font-family: 'Public Sans', sans-serif;
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
`

export const TextEdit = styled.p`
  font-family: 'Public Sans', sans-serif;
  font-style: normal;
  font-weight: 700;
  color: #2d749c;
  cursor: pointer;
  margin-right: 10px;
  margin-left: 10px;
`

export const BottomButtonsContainer = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  margin-top: 10px;
  justify-content: space-between;
`

export const ModalContainer = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
`

export const ModalHeader = styled.div`
  width: 100%;
  height: 10%;
  display: flex;
  justify-content: flex-end;
  align-items: center;
`

export const ModalBody = styled.div`
  width: 90%;
  height: 90%;
  display: flex;
  align-self: center;
  flex-direction: column;
  justify-content: flex-start;
  padding-bottom: 20px;
`

export const GridModal = styled.div`
  display: grid;
  grid-template-columns: 6fr 6fr;
  grid-gap: 10px;
  width: 100%;
  margin-top: 20px;
`

export const AnchorSection = styled.a`
  display: flex;
  flex-direction: column;
  text-decoration: none;
  align-self: center;
  justify-content: center;
  cursor: pointer;
  &:hover {
    text-decoration: none;
  }
`

export const ResetButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: 0;
  background: transparent;
  cursor: pointer;

  :active {
    box-shadow: 0 0px #666;
    transform: translateY(1px);
  }
`

export const SearchButton = styled.button`
  display: flex;
  padding: 12px 25px;
  justify-content: center;
  align-items: center;
  border-radius: 8px;
  border: 0;
  color: white;
  background-color: #2d749c;
  box-shadow: 0px 8px 16px 0px rgba(112, 112, 112, 0.24);
  cursor: pointer;

  :active {
    box-shadow: 0 0px #666;
    transform: translateY(1px);
  }
`

export const MagnifyingGlass = styled.img`
  width: 20px;
  height: 20px;
`

export const ButtonEdit = styled.div`
  font-family: 'Public Sans', sans-serif;
  font-size: 0.85rem;
  font-style: normal;
  font-weight: 700;
  color: #2d749c;
  cursor: pointer;

  :active {
    box-shadow: 0 0px #666;
    transform: translateY(1px);
  }
`

export const ButtonsContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 20px;
`

export const ButtonSave = styled.div`
  font-family: 'Public Sans', sans-serif;
  font-size: 0.85rem;
  font-style: normal;
  font-weight: 700;
  color: #2d749c;
  border: solid 1px #2d749c;
  border-radius: 20px;
  padding: 5px 10px;
  cursor: pointer;

  :active {
    box-shadow: 0 0px #666;
    transform: translateY(1px);
  }
`

export const ButtonCancel = styled.div`
  font-family: 'Public Sans', sans-serif;
  font-size: 0.85rem;
  font-style: normal;
  font-weight: 700;
  color: #d20000;
  cursor: pointer;

  :active {
    box-shadow: 0 0px #666;
    transform: translateY(1px);
  }
`

export const ButtonCreateNewUser = styled.button`
  color: #2d749c;
  font-weight: bold;
  cursor: pointer;
  margin: 10px 0px;
  background: none;
  border: none;
  padding: 0;
  display: flex;
  align-items: center;
  gap: 10px;
  justify-content: center;
  font-size: 16px;
  font-family: 'Public Sans', sans-serif;
  font-style: normal;
  font-weight: 700;

  &:hover {
    color: #2d749c;
    text-decoration: underline;
  }
`

export const Test360Icon = styled.img`
  width: 40px;
  height: 30px;
`
